<template>
	<v-dialog
		v-model="showDialog"
		max-width="800"
		@click:outside="showDialog = false"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card :tile="$vuetify.breakpoint.xs">
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">設計工数詳細</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-toolbar-title style="color: white" @click="closeDialog()"
					><v-icon>mdi-close</v-icon></v-toolbar-title
				>
			</v-toolbar>
			<v-sheet elevation="0" class="pa-2">
				<v-row no-gutters justify="end">
					<v-btn
						class="mr-2"
						color="secondary"
						dense
						v-if="authority_flag && isCurrentMonth"
						@click="openEditDialog(ordered_product.id)"
					>
						<v-icon class="mr-2">mdi-pencil</v-icon>編集</v-btn
					>
					<v-btn class="mr-2" dense disabled v-if="authority_flag && !isCurrentMonth">
						当月分のみ編集可</v-btn
					>
				</v-row>

				<v-sheet elevation="0" class="mt-4">
					<table width="100%" class="show-dialog-table mt-1">
						<tbody>
							<tr>
								<th width="30%" class="font-weight-bold">製造番号</th>
								<td
									width="70%"
									class="clickable font-weight-bold text-decoration-underline"
									@click="openOrderedProductShowDialog()"
								>
									{{ ordered_product.product_number }}
								</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">製品名</th>
								<td width="70%" v-if="ordered_product.product">
									{{ ordered_product.product.name }}
								</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">製品品番</th>
								<td width="70%" v-if="ordered_product.product">
									{{ ordered_product.product.product_code }}
								</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">数量</th>
								<td width="70%">{{ ordered_product.quantity }}</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">予定工数(単位: 時間)</th>
								<td width="70%" v-if="ordered_product.man_hour">
									{{ ordered_product.man_hour.planned_used_hours }}
								</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">実工数(単位: 時間)</th>
								<td width="70%" v-if="ordered_product.man_hour">
									{{ ordered_product.man_hour.used_hours }}
								</td>
							</tr>
							<tr>
								<th width="30%" class="font-weight-bold">設計者</th>
								<td
									width="70%"
									v-if="
										ordered_product &&
										ordered_product.man_hour &&
										ordered_product.man_hour.wage_cost
									"
								>
									{{ ordered_product.man_hour.wage_cost.name }}
								</td>
							</tr>
						</tbody>
					</table>
				</v-sheet>
				<OrderedProductSingleDialog v-if="orderedProductShow" :ordered_product="ordered_product" />
				<DesignCostEditDialog
					@updateDesignCost="updateDesignCost"
					@updatePlannedDesignCost="updatePlannedDesignCost"
					:dialog.sync="editDialog"
					:orderedProduct="ordered_product"
					:costCategory="cost_category"
				/>
			</v-sheet>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import OrderedProductSingleDialog from "../../shared/OrderedProductSingleDialog"
import DesignCostEditDialog from "./DesignCostEditDialog"

export default {
	components: {
		OrderedProductSingleDialog,
		DesignCostEditDialog,
	},
	props: {
		dialog: {
			type: Boolean,
			required: false,
			default: false,
		},

		orderedProductId: {
			type: null,
			required: false,
		},
	},
	data() {
		return {
			ordered_product: {},
			authority_flag: false,
			orderedProductShow: false,
			editDialog: false,
			currentMonth: new Date().getMonth() + 1,
			cost_category: {},
		}
	},

	methods: {
		closeDialog() {
			this.showDialog = false
		},
		fetchOrderedProductDesignCostInfo(ordered_product_id) {
			const headers = authenticate.setHeader()

			axios
				.get(`/erp/v1/design_costs/design_costs/${ordered_product_id}`, {
					headers,
				})
				.then((res) => {
					this.ordered_product = res.data.ordered_product
					this.cost_category = res.data.cost_category
					this.authority_flag = res.data.authority_flag
				})
				.catch((err) => {
					console.log(err)
					errorHandling.errorResponse(err)
				})
		},

		openEditDialog() {
			this.editDialog = true
		},

		openOrderedProductShowDialog() {
			this.orderedProductShow = true
		},

		updateDesignCost(orderedProduct, used_hours, man_hour_id, wage) {
			const headers = authenticate.setHeader()
			const params = {
				ordered_product_id: orderedProduct.id,
				used_hours: used_hours,
			}
			if (typeof wage == "object" && wage.id) {
				params.wage = wage.id
			} else {
				params.wage = wage
			}
			axios
				.put(`/erp/v1/design_costs/design_costs/${man_hour_id}`, params, {
					headers,
				})
				.then((response) => {
					this.editDialog = false
					this.$emit("updateDesignCost", response.data.ordered_product)
					this.fetchOrderedProductDesignCostInfo(orderedProduct.id)
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		updatePlannedDesignCost(orderedProduct, planned_used_hours, man_hour_id, wage) {
			const headers = authenticate.setHeader()
			const params = {
				ordered_product_id: orderedProduct.id,
				planned_used_hours: planned_used_hours,
			}
			if (typeof wage == "object" && wage.id) {
				params.wage = wage.id
			} else {
				params.wage = wage
			}
			axios
				.put(`/erp/v1/design_costs/design_costs/${man_hour_id}`, params, {
					headers,
				})
				.then((response) => {
					this.editDialog = false
					this.$emit("updateDesignCost", response.data.ordered_product)
					this.fetchOrderedProductDesignCostInfo(orderedProduct.id)
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
	computed: {
		showDialog: {
			get() {
				return this.dialog
			},
			set(newVal) {
				return this.$emit("update:dialog", newVal)
			},
		},
		isCurrentMonth() {
			const targetMonth = new Date(this.ordered_product.man_hour.created_at).getMonth() + 1
			return this.currentMonth == targetMonth
		},
	},
	watch: {
		orderedProductId(newVal, oldVal) {
			if (newVal == oldVal) return
			this.fetchOrderedProductDesignCostInfo(newVal)
		},
	},
}
</script>

<style scoped lang="scss">
@media (max-width: 700px) {
	.v-btn {
		display: block !important;
		margin-bottom: 10px;
		width: 40%;
		text-align: center;
	}
}
</style>
